import { useState } from "react";
import { ColumnFiltersState } from "@tanstack/react-table";

export const useDataTableFilters = (initialState: ColumnFiltersState) => {
  return useState<ColumnFiltersState>(initialState);
};
